import { render } from "./Waste.vue?vue&type=template&id=36c5cfc3"
import script from "./Waste.vue?vue&type=script&lang=js"
export * from "./Waste.vue?vue&type=script&lang=js"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__